// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".companySelector .ReactTable {\n    height: 184px;\n}\n.ReactTable .rt-td {\n    text-align:center;\n}\n\n.ReactTable .rt-thead {\n    overflow-y: scroll\n}\n\n.companies {\n    height: 80px;\n}", ""]);
// Exports
module.exports = exports;
